import { Icon, Tooltip } from '@chakra-ui/react';
import { PiCheckCircle, PiWarningCircle } from 'react-icons/pi';

interface IAccountStatusBadgeProps {
  confirmPending: boolean;
}

const AccountStatusBadge = ({
  confirmPending,
}: IAccountStatusBadgeProps): JSX.Element => (
  <Tooltip
    placement="bottom"
    hasArrow
    label={confirmPending ? 'Pendente' : 'Confirmado'}
  >
    <span>
      <Icon
        as={confirmPending ? PiWarningCircle : PiCheckCircle}
        color={confirmPending ? 'gray.400' : 'green.400'}
        fontSize={26}
        cursor="pointer"
      />
    </span>
  </Tooltip>
);

export default AccountStatusBadge;
